export const EMAIL_SECTION_EXIT_OPTIONS = {
  STAY: "stay",
  CONTINUE_DIALING: "continue-dialing",
} as const;
